import { render, staticRenderFns } from "./UploadVisitPointList.vue?vue&type=template&id=28c35d68"
import script from "./UploadVisitPointList.vue?vue&type=script&lang=js"
export * from "./UploadVisitPointList.vue?vue&type=script&lang=js"
import style0 from "./UploadVisitPointList.vue?vue&type=style&index=0&id=28c35d68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports